import { computed, reactive } from 'vue'

function useReducer(reducer, ...toReduce) {
  const values = reactive(new Set())

  function remove(value) {
    return values.delete(value)
  }

  function add(value) {
    values.add(value)
    return () => remove(value)
  }

  for (let i = 0; i < toReduce.length; i += 1) {
    const value = toReduce[i]
    add(value)
  }

  const reduced = computed(() => (
    Array.from(values).reduce((prev, current, idx, arr) => (
      reducer(prev, current.value, idx, arr)
    ), undefined)
  ))

  return {
    add,
    remove,
    reduced,
  }
}

export default useReducer
